import {Component} from '@angular/core';
export class PromptComponent {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'prompt',
    template: `
        <ng-content select="prompt-header"></ng-content>
        <ng-content select="prompt-body"></ng-content>
        <div class="form-group">
            <ng-content select="prompt-confirm"></ng-content>
            <ng-content select="prompt-cancel"></ng-content>
        </div>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PromptComponent_tsickle_Closure_declarations() {
/** @type {?} */
PromptComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PromptComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
